<!-- 收货人信息table -->
<template>
    <el-dialog append-to-body title="最多选择10个订单" :visible.sync="centerDialogVisible" width="67%">
        <el-table border row-key="orderMainId" @selection-change="handleSelectionChange"
            :header-cell-style="{ backgroundColor: '#FDEFE7', color: '#000000' }" ref="multipleTable" :data="tableData"
            tooltip-effect="dark">
            <el-table-column :selectable="selectable" :reserve-selection="true" align="center" type="selection"
                width="55">
            </el-table-column>
            <el-table-column width="150" align="center" label="收款时间">
                <template slot-scope="scope"> {{ scope.row.payDate | dateFormatHms }} </template>
            </el-table-column>
            <el-table-column width="250" prop="payName" align="center" label="付款方名称"> </el-table-column>
            <el-table-column width="100" prop="payPrice" align="center" label="收款金额">
                <template slot-scope="scope"><span style="color:blue">¥{{ scope.row.payPrice }}</span> </template>
            </el-table-column>
            <el-table-column width="100" align="center" label="付款方式">
                <template slot-scope="scope"> {{ scope.row.payType == 1 ? '微信' : '线下转账' }} </template>
            </el-table-column>
            <el-table-column width="200" align="center" label="备注">
                <template slot-scope="scope"> {{ scope.row.remark }} </template>
            </el-table-column>
            <el-table-column align="center" width="130" label="是否到账">
                <template slot-scope="scope">
                    <span>{{ scope.row.status == 1 ? '已到账' : scope.row.status == 3 ? '退款中' : scope.row.status == 4 ?
        '已退款' : '未到账' }}
                    </span>
                    <p v-if="scope.row.refundDate">{{ scope.row.refundDate | dateFormatHms }} </p>
                </template>
            </el-table-column>
            <!-- <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button type="primary" v-if="scope.row.status == 1" style="padding: 0.05rem 0.05rem;"
                        @click="refurePay(scope.row)">退款</el-button>
                    <el-button type="primary" v-if="scope.row.status == 0" style="padding: 0.05rem 0.05rem;"
                        @click="deleteDetailData(scope.row)">删除</el-button>
                    <el-button type="primary" v-if="scope.row.status == 0" style="padding: 0.05rem 0.05rem;"
                        @click="uploadFile(scope.row)">编辑</el-button>
                    <el-button type="primary" v-if="scope.row.status == 1 || scope.row.status == 0"
                        style="padding: 0.05rem 0.05rem;" @click="invoiceClick(scope.row)">开发票</el-button>
                </template>
            </el-table-column> -->
        </el-table>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="save">确 定</el-button>
            <el-button @click="centerDialogVisible = false">取 消</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        //默认勾选的那条数据
        defaultGou: {
            type: String,
            default: "",
        }
    },
    data() {
        return {
            tableData: [],
            centerDialogVisible: false,
            multipleSelection: [],
        }
    },
    computed: {},
    watch: {},
    methods: {
        initClick(arr, ids) {
            console.log(ids,'skadkskad');
            this.tableData = arr
            this.centerDialogVisible = true
            this.$nextTick(() => {
                this.tableData.forEach(row => {
                    if(ids.findIndex(n => n.orderId === row.orderMainId) !== -1) {
                        this.$refs.multipleTable.toggleRowSelection(row, true);
                    }
                })
            });
        },
        clearGou() {
            this.$refs.multipleTable.clearSelection()
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        selectable(row) {
            return !(row.orderMainId == this.defaultGou)
        },
        //保存
        save() {
            if (this.multipleSelection.length > 10) {
                this.$message.warning({ message: '一次最多勾选十条订单' });
            } else {
                let ids = []
                let price = 0 //总价格
                this.multipleSelection.forEach(item => {
                    let obj = {
                        orderId: item.orderMainId,
                        price: item.invoicePrice
                    }
                    ids.push(obj)
                    price += ( Number(item.payPrice) - Number(item.invoicePrice))
                })
                this.$message.success({ message: '保存成功' })
                this.$emit('orderClick', ids, price)
                this.centerDialogVisible = false
            }
        },
    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped></style>